import { Plus } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import {
    Alert,
    Button,
    Col,
    Form,
    Image,
    Modal,
    Row,
    Spinner,
} from 'react-bootstrap';
import { useRequestEmailMutation } from './emailApi';
import SubmittedRequest from '../../Assets/Img/submitted_request.png';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { getSecureItem } from "../../utils/secureStorage";
const AddEmail = ({ setLoading }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [error, setError] = useState('');
    const [confirmModalLoading, setConfirmModalLoading] = useState(false);
    const user = getSecureItem('UserData');

    const [RequestEmail] = useRequestEmailMutation();
    const [requestEmailConfig, setRequestEmailConfig] = useState({
        requestfrom: user.email,
        requestfromrole: user.userType,
    });
    const [newEmail, setNewEmail] = useState('');
    const handleChange = (e) => {
        setRequestEmailConfig((prevValues) => {
            return {
                ...prevValues,
                [e.target.name]: e.target.value,
            };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setModalLoading(true);
        setError('');
        try {
            setNewEmail(requestEmailConfig.newemail);
            const res = await RequestEmail(requestEmailConfig);
            console.log(res, 'datadata');
            if (res?.error?.data) {
                setError(
                    res.error.data == 'Patient Unique Code does not exists'
                        ? 'patientCodeNotExist'
                        : 'emailNotExist'
                );
                setModalLoading(false);
            }

            if (res?.data) {
                setShow(false);
                setRequestEmailConfig({
                    requestfrom: user.name,
                    requestfromrole: user.userType,
                });
                setModalLoading(false);
                setConfirmModalLoading(true);
            } else {
            }
        } catch (error) {
            console.log(error, 'errorerror');
        }
    };

    return (
        <>
            <Button variant="primary" onClick={() => setShow(true)}>
                {' '}
                <Plus width={14} height={14} />
                {t('newEmailChangeRequest')}
            </Button>
            <Modal
                show={show}
                size="lg"
                onHide={() => {
                    setRequestEmailConfig({
                        requestfrom: user.email,
                        requestfromrole: user.userType,
                    });
                    setError('');
                    setModalLoading(false);
                    setShow(false);
                }}
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t('newEmailChangeRequest')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="modal_form">
                        <Row>
                            <Col md={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {t('patientUniqueCode')} *
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="patientuniquecode"
                                        value={
                                            requestEmailConfig.patientuniquecode
                                        }
                                        onChange={handleChange}
                                        placeholder={t('inputText')}
                                        required
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('wrongEmail')} *</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="email"
                                        value={requestEmailConfig.email}
                                        onChange={handleChange}
                                        placeholder={t('inputText')}
                                        required
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={12}>
                                <Form.Group className="">
                                    <Form.Label>
                                        {t('correctEmail')} *
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="newemail"
                                        value={requestEmailConfig.newemail}
                                        onChange={handleChange}
                                        placeholder={t('inputText')}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            {error !== '' && (
                                <Col md={12} className="mt-3">
                                    <Alert
                                        style={{ width: '100%' }}
                                        variant={'danger'}
                                    >
                                        {t(error)}
                                    </Alert>
                                </Col>
                            )}
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            type="submit"
                            variant="primary"
                            disabled={modalLoading}
                        >
                            {modalLoading && (
                                <Spinner
                                    animation="border"
                                    role="status"
                                    size="sm"
                                >
                                    <span className="visually-hidden">
                                        Loading...
                                    </span>
                                </Spinner>
                            )}{' '}
                            {t('submitRequest')}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
            <Modal
                show={confirmModalLoading}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Body className="text-center">
                    <div
                        className="mx-auto p-4"
                        style={{ width: '100%', maxWidth: '362px' }}
                    >
                        <Image src={SubmittedRequest} width={88} />
                        <h4>{t('requestSubmitted')}</h4>
                        <p>
                            {t('yourRequestToChangeEmailTo')} {newEmail}{' '}
                            {t('hasBeenReceived')}
                        </p>
                        <Button
                            variant="primary"
                            className="w-100"
                            size="lg"
                            onClick={() => {
                                setConfirmModalLoading(false);
                                setLoading(true);
                            }}
                        >
                            {t('okay')}
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};
export default AddEmail;
